import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { Brand } from "@/components/Brand";
import { Loader2, CheckCircle2, XCircle, Clock } from "lucide-react";

const brl = (v) => (v || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

/** Botão "Pagar agora" da mensagem de WhatsApp: confere a cobrança e leva ao pagamento (Mercado Pago). */
export default function PayCharge() {
  const { id } = useParams();
  const [c, setC] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    api.get(`/public/charges/${id}`)
      .then((r) => { setC(r.data); if (r.data.link) window.location.replace(r.data.link); })
      .catch((e) => setErr(e.response?.status === 404 ? "Cobrança não encontrada. Confira o link ou fale com o IEP."
        : "Não foi possível abrir o pagamento agora. Tente de novo em alguns minutos ou fale com o IEP."));
  }, [id]);
  const msg = c && !c.link && ({
    paga: [CheckCircle2, "text-green-600", "Esta cobrança já foi paga. Obrigado!"],
    vencida: [Clock, "text-amber-600", "Esta cobrança venceu. Fale com o IEP para receber um novo link."],
    cancelada: [XCircle, "text-slate-500", "Esta cobrança foi cancelada."],
    estornada: [XCircle, "text-slate-500", "Este pagamento foi estornado."],
  }[c.status] || [XCircle, "text-slate-500", "Esta cobrança não está disponível."]);
  return (
    <div className="min-h-screen grid place-items-center bg-[#F8FAFC] px-4">
      <div className="bg-white border border-slate-200 rounded-2xl shadow-sm p-8 max-w-md w-full text-center">
        <div className="flex justify-center mb-6"><Brand size="md" /></div>
        {err ? <p className="text-slate-700">{err}</p> : !c || c.link ? (
          <><Loader2 className="h-8 w-8 animate-spin text-[#232D4F] mx-auto" />
            <p className="text-slate-500 mt-3">Abrindo o pagamento{c ? ` de ${c.description} (${brl(c.amount)})` : ""}…</p>
            {c?.link && <a href={c.link} className="inline-block mt-5 text-sm text-[#1E9E2A] font-semibold hover:underline">Se não abrir, toque aqui</a>}</>
        ) : (() => { const [I, cls, t] = msg; return (<>
          <I className={`h-10 w-10 mx-auto ${cls}`} />
          <div className="font-display text-lg font-semibold text-slate-800 mt-3">{c.description} · {brl(c.amount)}</div>
          <p className="text-slate-600 mt-2">{t}</p></>); })()}
      </div>
    </div>
  );
}
